import { Z_RECONNECT } from '../../../features/quickstart/config/zIndexLayers';
import { RECONNECT_FRAME_HOLD_MS } from '../useVideoFrameStall';

export { RECONNECT_FRAME_HOLD_MS };

export type ReconnectingOverlayProps = {
  visible: boolean;
  /** Deprecated for UI: accepted but never shown (5A hide attempt counter). */
  attempt?: number;
};

/**
 * Full-cover overlay shown during the reconnect / network failover window.
 *
 * Kept mounted while the parent owns a reconnect latch so AnimatePresence
 * exit fades cannot fight a second overlay during resetIncomingMedia.
 * Visibility is driven by opacity/visibility only (no unmount flap).
 */
export const ReconnectingOverlay = ({ visible }: ReconnectingOverlayProps) => (
  <div
    data-testid='reconnecting-overlay'
    role='status'
    aria-live='polite'
    aria-hidden={!visible}
    className='pointer-events-none fixed inset-0 flex flex-col items-center justify-center bg-black/95 backdrop-blur-md'
    style={{
      zIndex: Z_RECONNECT,
      opacity: visible ? 1 : 0,
      visibility: visible ? 'visible' : 'hidden',
      transition: 'none',
    }}
  >
    <div className='flex flex-col items-center gap-4 px-8 py-6 text-center'>
      <div className='h-10 w-10 animate-spin rounded-full border-4 border-white/20 border-t-white' />
      <div className='text-lg font-semibold text-white'>Connection lost, recovering…</div>
    </div>
  </div>
);
